import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading text-center text-foreground-950">
            分类索引
          </h2>
          <p className="mt-3 text-sm text-foreground-500 text-center">
            按主题快速找到你想看的漫画类型
          </p>

          <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {indexData.map((item) => (
              <a
                key={item.id}
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="group flex items-start gap-4 p-5 bg-background-50 rounded-2xl border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
              >
                <span className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center text-accent-700 font-heading text-lg shrink-0 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                  {item.letter}
                </span>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
                    {item.desc}
                  </p>
                  <span className="inline-block mt-1.5 text-xs text-foreground-400 whitespace-nowrap">
                    {item.count.toLocaleString()} 部作品
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}